
<div class="body-optout-main-container">

  <div class="optout-main-container">
    <div class="email-display">{{maskedEmail}}</div>
    <h1 class="title" [style.color]="titleColor">{{ titleHeading }}</h1>
    <p class="description">
      You can choose to opt out of the following<br /> type of email communications we send.
    </p>
  </div>

  <div class="optout-container">
    <!--<button class="optout-all-btn">Opt Out of All Emails</button>-->

    <div class="preferences-section">
      <table class="preferences-table">
        <thead>
          <tr style=" border-bottom: 1px solid #e0e0e0;">
            <th class="email-type-header">Email Type</th>
            <th class="optout-header">Opt Out</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding-top: 22px;">
              <span style="display: flex; width: 320px; font-family: Colfax, Helvetica, sans-serif; text-transform: uppercase; ">{{groupName}}</span>
              <p style="display: flow; width: 370px; font-size: 14px; font-family: Colfax, Helvetica, sans-serif; ">
                <!--These emails are for system emails. Unsubscribes will remove from SGC Marketing list-->
                Selecting YES will remove this email from the SGC Marketing List. You will continue to receive
                the mandatory transactional emails related to your account in accordance with our <a routerLink="/terms">Terms & Conditions</a> and <a routerLink="/privacy">Privacy Notice</a>.
              </p>
            </td>
            <td>
              <!--<label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="isMarketingOptOut" (change)="onToggleChange()" />
              <span class="slider"></span>
            </label>-->
              <!--<label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="isMarketingOptOut" (change)="onToggleChange()" />
              <span class="slider">
                <span class="slider-label no">NO</span>
                <span class="slider-label yes">YES</span>
              </span>
            </label>-->
              <div class="toggle-btn-container">
                <button class="toggle-btn" [class.active]="!isMarketingOptOut" (click)="setToggle(false)">NO</button>
                <button class="toggle-btn" [class.active]="isMarketingOptOut" (click)="setToggle(true)">YES</button>
              </div>

            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--<div class="footer">
      <button class="save-btn button-save" style="width:35%;" [disabled]="isSaving" (click)="savePreferences()">
        <span *ngIf="!isSaving">Save Preference</span>
        <span *ngIf="isSaving">
          <i class="fa fa-spinner fa-spin"></i> Saving...
        </span>
      </button>
    </div>-->
  </div>

  

</div>
